
import {defineComponent} from 'vue';

export default defineComponent({
    name: 'ShopMenu',
    props:{
        show: Boolean,
        menuCats: {
            type: Array,
            default(){
                return []
            }
        },
        topStore: {
            type: Array,
            default(){
                return []
            }
        },
        store: {
            type: Array,
            default(){
                return []
            }
        }
    },
    emits: ['update:show'],
    data(){
        return {
            active:1,
            menu:false,
            flag: false,
            listCat: [],
            listStore: [] as any
        }
    },
    created() {
        window.addEventListener('click', (e) => {
            if(!this.flag){
                this.menu= this.$el.contains(e.target)
                if(!this.menu){
                    this.$emit('update:show',false)
                }
            }
            this.flag= false
        })

    },
    watch:{
        show(val){
            this.flag= true
            this.menu= val
        },
        menuCats( list ){
            this.listCat = this.arrayColumn( list )
        },
        store( list ){
            this.listStore = this.arrayColumn( list )
        }
    },
    methods: {
        arrayColumn(list: any, size= 6){
            var results: any = [];
            var cloneList: any= JSON.parse( JSON.stringify( list ) )
            while ( cloneList.length ) {
                results.push( cloneList.splice(0, size) );
            }
            return results
        },
        handleFocus() {
            console.log('focus')
        },
        handleFocusOut() {
            console.log('out')
        }
    }
});
